import { useState, useEffect } from 'react'

const DEFAULT_DURATION = 1 * 60 * 1000 //1 min

const useTimer = (startTime: number, duration: number = DEFAULT_DURATION) => {
  const [timeLeft, setTimeLeft] = useState(0)

  useEffect(() => {
    if (startTime) {
      const nextAvailableTime = startTime + duration
      const updateTimer = () => {
        const currentTime = new Date().getTime()
        const remainingTime = nextAvailableTime - currentTime
        setTimeLeft(Math.max(remainingTime, 0))
      }
      updateTimer()
      const intervalId = setInterval(updateTimer, 1000)
      return () => clearInterval(intervalId)
    }
  }, [startTime, duration])

  const formatTimeLeft = (milliseconds: number) => {
    const totalSeconds = Math.floor(milliseconds / 1000)
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
  }

  return { timeLeft, formatTimeLeft }
}

export default useTimer
